/**
 * Javascript specific to ul dropdowns
 */

(function (window, document, $) {
    'use strict';

    var $scoped = $('ul.jh-ul-dropdown');
    var $dropdown = $scoped.find("li:first");

    $dropdown.click(function() {
       $(this).closest(".jh-ul-dropdown").toggleClass("jh-ul-dropdown--active");
    });

})( window, document, jQuery );
